import { render, staticRenderFns } from "./CreateTimingMail.vue?vue&type=template&id=18e228cc&scoped=true"
import script from "./CreateTimingMail.vue?vue&type=script&lang=js"
export * from "./CreateTimingMail.vue?vue&type=script&lang=js"
import style0 from "./CreateTimingMail.vue?vue&type=style&index=0&id=18e228cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e228cc",
  null
  
)

export default component.exports